import { Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import DashboardContentCard from 'components/foundation/dashboard/DashboardContentCard/DashboardContentCard';
import { DashboardSettings } from 'containers/dashboard/types/types';
import useTimeLogFeedEnabled from 'containers/time-log-feed/useTimeLogFeedEnabled/useTimeLogFeedEnabled';
import useTimeLogNavigation from 'hooks/navigation/useTimeLogNavigation';
import { t } from 'i18next';
import { colors } from 'utils/constants/colors';
import TimeLogFeedDashboardCardList from './TimeLogFeedDashboardCardList/TimeLogFeedDashboardCardList';

export interface ITimeLogFeedDashboardCardProps {
  setting: DashboardSettings['timeLogs'];
  theme: Theme.DARK | Theme.LIGHT;
  className?: string | object;
}

function TimeLogFeedDashboardCard({ setting, theme, className }: ITimeLogFeedDashboardCardProps) {
  const navigate = useTimeLogNavigation();
  const timeLogFeedEnabled = useTimeLogFeedEnabled();

  if (!timeLogFeedEnabled) {
    return null;
  }

  const classes = classNames('time-log-feed-dashboard-card', className);

  return (
    <DashboardContentCard
      subheaderValue={setting.title}
      tabColor={colors.primary}
      theme={theme}
      className={classes}
      rightLabel={t('View All')}
      onRightLabelClick={navigate}
    >
      <TimeLogFeedDashboardCardList theme={theme} />
    </DashboardContentCard>
  );
}

export default TimeLogFeedDashboardCard;
